import { render, staticRenderFns } from "./EditProjectGroup.vue?vue&type=template&id=13297b67"
import script from "./EditProjectGroup.vue?vue&type=script&lang=js"
export * from "./EditProjectGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports